export const GET_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/get_new_business_natures';
export const GET_SINGLE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/get_single_new_business_natures';
export const UPDATE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/update_new_business_natures';
export const CREATE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/create_new_business_natures';
export const REMOVE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/remove_new_business_natures';
export const ACTIVATE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/activate_new_business_natures';
export const DEACTIVATE_NEW_BUSINESS_NATURES =
  'NEW_BUSINESS_NATURES/deactivate_new_business_natures';

// business lines

export const GET_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_LINES/get_new_business_lines';
export const UPDATE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_LINES/update_new_business_lines';
export const CREATE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_LINES/create_new_business_lines';
export const REMOVE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_LINES/remove_new_business_lines';
export const GET_SINGLE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_LINES/get_single_new_business_lines';

export const ACTIVATE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_NATURES/activate_new_business_lines';
export const DEACTIVATE_NEW_BUSINESS_LINES =
  'NEW_BUSINESS_NATURES/deactivate_new_business_lines';

export const GET_NEW_TAX_REVENUES_GARBAGE =
  'NEW_BUSINESS_LINES/get_new_tax_revenues_garbage';
export const GET_NEW_TAX_REVENUES_LICENSE =
  'NEW_BUSINESS_LINES/get_new_tax_revenues_license';
export const GET_NEW_TAX_REVENUES_PERMIT =
  'NEW_BUSINESS_LINES/get_new_tax_revenues_permit';
export const GET_NEW_TAX_REVENUES_SANITARY =
  'NEW_BUSINESS_LINES/get_new_tax_revenues_sanitary';

export const GET_BUSINESS_LINE_OTHER_FEES =
  'NEW_BUSINESS_LINES/get_business_line_other_fees';
export const GET_REPORT_ACCESS = 'NEW_BUSINESS_LINES/get_report_access';

export const FORM_DATA = {
  name: '',
  code: '',
};

export const BUSINESS_LINES_FORM_DATA = {
  code: '',
  name: '',
  garbage_code: '',
  license_code: '',
  permit_code: '',
  sanitary_code: '',
  keyword: '',
  other_fees: [],
};
